<div nz-row class="company-intro-image"></div>
<div class="background-circles"></div>
<div nz-row class="message-title center-parent" style="margin-bottom: 0px;">
  <span class="title align-center">CEO 메시지</span>
  <p class="content" style="color: #707070; text-align: left; margin-left: 527px; margin-top: 120px;">안녕하십니까? 현대그린테크(주) 대표이사 천명환, 정해수입니다.<br/>
    언제나 한결같은 마음으로 현대그린테크를 믿고 성원해 주신 고객 여러분들께 감사드립니다.<br/>
    <br/>
    당사는 2001년 3월 현대전자산업(현 SK Hynix)으로부터 분사 이후 SK Hynix 대리점을 운영하는 반도체사업부는<br/>
    세계 최고의 SK Hynix 제품을 다양한 제조업체와 유통시장에 공급함은 물론 당사의 기술 인력을 활용하여<br/>
    기술지원 및 서비스에 최선을 다하고 있습니다.<br/>
    <br/>
    엘리베이터용 부품을 생산하는 판금사업부는 판금분야에서 가장 효율적인 유연 생산 시스템(FMS)인<br/>
    Salvagnini S4+P4 라인을 도입하여 펀칭, 절단, 절곡의 전체 판금 공정을 완전히 자동화한 생산 시스템을<br/>
    구축하였으며, 생산 제품의 높은 정밀도를 유지하여 최상의 생산 품질을 보증합니다.<br/>
    <br/>
    아울러 저희 현대그린테크는 고객 만족을 최우선으로 신시장 개척 및 우수한 품질과<br/>
    서비스 제공을 위하여 매진할 것입니다.<br/>
    <br/>
    더욱 더 발전하는 현대그린테크가 될 것을 약속드리며 고객 여러분의 많은 관심과 성원을 부탁드립니다.<br/>
    <br/>
    감사합니다.</p>
</div>
<!-- <div style="text-align: right; margin-right: 500px;">
  <img style="width: 196px; height: 105px;" src="../../../../assets/images/sign.png">
</div> -->
<div nz-row class="ceo-bottom">
  <span style="margin-left: 560px; margin-top: 7px;">현대그린테크(주) 대표이사 천명환, 정해수</span>
</div>
<div class="main-footer" nz-row>
  <p>COPYRIGHT BY (C) 2009 HYUNDAI GREEN TECH ALL RIGHTS RESERVED.<br/>
    [SEOUL]  T 02-2115-8815  F 02-2115-8818  [CHEON-AN] T 041-582-2214, 2215  F 041-588-2215</p>
</div>
